import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Config } from '../../../config/config';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DMHeThongKhacService {

    constructor(
        private http: Http
    ) { }
    DanhSach_KetQuaXuLy() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {};
        return this.http.post(Config.apiUrl + 'DMHeThongLienKet/DanhSach_KetQuaXuLy', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSach_ThaoTac() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {};
        return this.http.post(Config.apiUrl + 'DMHeThongLienKet/DanhSach_ThaoTac', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    KetQuaXuLy_BuocThucHien(IdBuoc:number,IdCauHinhBuoc:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + 'DMHeThongLienKet/KetQuaXuLy_BuocThucHien?IdBuoc='+IdBuoc+"&IdCauHinhBuoc="+IdCauHinhBuoc, { headers: headers }).map(resp => resp.json());
    }
    Luu_KetQuaXuLy(KetQuaXuLy) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = KetQuaXuLy;
        return this.http.post(Config.apiUrl + 'DMHeThongLienKet/Luu_KetQuaXuLy', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }   
    Huy_KetQuaXuLy(KetQuaXuLy) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = KetQuaXuLy;
        return this.http.post(Config.apiUrl + 'DMHeThongLienKet/Huy_KetQuaXuLy', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    } 
    GetListFromPagination(paging:number,maxSize:number, keyword: string) {
        let headers = new Headers();
        let currentPage = paging - 1;
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +"DMHeThongLienKet/GetList?currentPage="+ currentPage+"&maxSize="+ maxSize + "&keyword=" + keyword, { headers: headers }).map(resp => resp.json());       
    } 
    ds_HeThongLienKet() {
        let headers = new Headers();        
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl +"DMHeThongLienKet/ds_HeThongLienKet", { headers: headers }).map(resp => resp.json());       
    } 
    
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/danhmuc/dm-hethongkhac/dm-hethongkhac.service.ts